import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { InvalidOrderReasonStaff } from "./InvalidOrderReasonStaff";
import type { InvalidOrderReportDTOBase } from "./InvalidOrderReportDTOBase";
import type { OrderRef } from "./OrderRef";
import type { ReportRunRef } from "./ReportRunRef";

export class InvalidOrderReportStaff implements InvalidOrderReportDTOBase {
  constructor(public readonly reportId: number, public readonly runId: ReportRunRef, public readonly orderId: OrderRef, public readonly evaluationRunId: number, public readonly checkedAt: Date, public readonly checkoutAt: Date | null, public readonly paidOn: Date | null, public readonly invalid: boolean, public readonly unverifiable: boolean, public readonly reused: boolean, public readonly hasMultiDayPayments: boolean | null, public readonly settlementDays: string | null, public readonly reasons: Array<InvalidOrderReasonStaff> | null) {
    this.cbiServiceContext = null;
    this.reasonsLoaded = this.reasons != null;
    this.reasonsCached = this.reasons;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private reasonsLoaded: boolean;
  private reasonsCached: Array<InvalidOrderReasonStaff> | null;
  async reasonsLazy(): Promise<Array<InvalidOrderReasonStaff>> {
    if (!this.reasonsLoaded) {
      this.reasonsCached = await this.cbiServiceContext!.reportService().getInvalidOrderReportStaffReasons(this.reportId);
      this.reasonsLoaded = true;
    }
    return this.reasonsCached!;
  }
}
